import React, { Component } from 'react';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import XLlabelDialog from './XLlabelDialog';

class XLlabelDialogContainer extends Component {

  render() {

    return (
      <ProjectConsumer>
        {({ defaultLang, id: projectIRI }) => (
          <XLlabelDialog
            graph={this.props.graph}
            defaultLang={defaultLang}
            projectIRI={projectIRI}
            iriOptions={this.props.iriOptions}
            useSlashIRI={this.props.useSlashIRI}
            useUuidIRI={this.props.useUuidIRI}   
            onAddExistingLabel={this.props.addExistingLabel}
            onAddNewLabel={this.props.addNewLabel}
            schemeIRI={this.props.id} />
        )}
      </ProjectConsumer>
    );
  }

}

export default XLlabelDialogContainer;